import React from 'react';
import Organigrama from '../../commons/Organigrama';
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import DateleFirmei from '../../commons/dialogs/DateleFirmei';
import CustomAppBar from '../../commons/AppBar';
import Utils from '../../providers/Utils';
import AlertNew from '../../commons/dialogs/AlertNew';
import LocalStorage from '../../providers/LocalStorage';



export default class OrganigramaRoute extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            objDateFirma: {},
            isOpenDateFirma: false,
            coteTva: [
                { id: 1, nume: 'Platitor TVA' },
                { id: 2, nume: 'Neplatitor TVA' },
            ],
            disabled: true,
            alertView:false

        }
    }


    ls = new LocalStorage().GetUserData()

    componentDidMount() {
        this.access()
        this.getDateFirma()
    }


    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.IsAdmin === 1 ? false : true })
        }


    }

    getDateFirma = async () => {
        let ws = new Ws();


        let countDate = await ws.customSelect('select count(*) as nr from companie_date where 1 = @p1', {
            p1: 1
        })

        // console.log('countDate :', countDate);

        if (countDate.Succes) {
            if (countDate.Content[0].nr > 0) {
                let getDate = await ws.customSelect('select * from companie_date where id = @p1', {
                    p1: 1
                })
                console.log('getDate :>> ', getDate);

                if (getDate.Succes) {
                    let disabled = true
                    if (getDate.Content[0].cui.length < 7) {
                        disabled = true
                    } else {
                        disabled = false
                    }
                    this.setState({
                        objDateFirma: getDate.Content[0],
                        disabled: disabled
                    })
                }
            } else {
                let insertDate = await ws.insert('companie_date', {
                    nume: 'Introdu Nume',
                    adresa: 'Introdu Adresa',
                    cui: 0,
                    nr_inregistrare: 0,
                    cota_tva: 0
                })
                // console.log('insertDate :', insertDate);
            }
        }


    }


    changeDate = n => ev => {

        let cloneDate = { ...this.state.objDateFirma }

        let disabled = this.state.disabled
        if (n === 'cui') {
            if (ev.target.value.length < 7) {
                disabled = true
            } else {
                disabled = false
            }
        }

        cloneDate[n] = ev.target.value

        this.setState({
            disabled: disabled,
            objDateFirma: cloneDate
        })
    }


    updateFirma = async (f) => {

        // console.log('f :', f);

        let ws = new Ws();

        let objToUpdate = {
            nume: f.nume || "",
            adresa: f.adresa || "",
            cui: f.cui || 0,
            nr_inregistrare: f.nr_inregistrare || 0,
            cota_tva: f.cota_tva || 0
        }

        let updateF = await ws.update('companie_date', objToUpdate, { id: f.id })

        if (updateF.Succes) {
            this.setState({ isOpenDateFirma: false })
        }



    }

    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }



    dataAzi = () => {
        let u = new Utils()

        let dataAzi = u.defaultData()

        if (this.dictionary.date === 'en') {
            return u.dataPrescurtataEng(dataAzi)
        } else {
            return u.dataPrescurtataRomana(dataAzi)
        }
    }

    render() {
        return (
            <div>


                <CustomAppBar history={this.props.history} title={this.dictionary.managementUtilizatori.managementDepartamente} appBarButtons={this.buildAppBarButtons()} />
                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />

                
              <DateleFirmei
                    open={this.state.isOpenDateFirma}
                    dialogClose={()=>{this.setState({isOpenDateFirma:false})}}
                    dateFirma={this.state.objDateFirma}
                    changeDate={this.changeDate}
                    updateFirma={this.updateFirma}
                    limba={this.dictionary}
                    cote_tva={this.state.coteTva}
                    disabled={this.state.disabled}
                    />

                <div 
               onClick={ ()=>{this.setState({isOpenDateFirma:true})}}
               style={{padding:20,
                                    fontWeight:600,
                                    borderRadius:4,
                                    position:'fixed',
                                    cursor:'pointer',
                                    left:50,
                                    zIndex:1001,
                                    top:80,
                                                
                                                color:'white',
                                                backgroundColor:'rgb(27, 167, 154)'}}>
                                              
                                                        

                           {this.dictionary.organigrama.dateleFirmei}
                        
                                  
                                  </div>
                <Organigrama
                    scop='Organigrama'
                />
            </div>
        );
    }
}